import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Utility function to merge classNames with proper Tailwind CSS precedence
 * Uses clsx for conditional classes and tailwind-merge to handle conflicts
 * 
 * @param {...any} inputs - Class names, objects, or arrays to merge
 * @returns {string} Merged class names
 */
export function cn(...inputs) {
	return twMerge(clsx(inputs));
} 